import { friendsAPI } from './baseService'

export const eventSocialService = {
  getFriendsEvents: async () => {
    const response = await friendsAPI.get('/api/events/friends/feed')
    return response.data
  },

  likeEvent: async (eventId) => {
    const response = await friendsAPI.post(`/api/events/${eventId}/like`)
    return response.data
  },

  unlikeEvent: async (eventId) => {
    const response = await friendsAPI.delete(`/api/events/${eventId}/like`)
    return response.data
  },

  addComment: async (eventId, text) => {
    const response = await friendsAPI.post(`/api/events/${eventId}/comments`, {
      text
    })
    return response.data
  },

  deleteComment: async (eventId, commentId) => {
    const response = await friendsAPI.delete(`/api/events/${eventId}/comments/${commentId}`)
    return response.data
  },

  editComment: async (eventId, commentId, text) => {
    const response = await friendsAPI.put(`/api/events/${eventId}/comments/${commentId}`, {
      text
    })
    return response.data
  },

  addCommentReaction: async (eventId, commentId, emoji) => {
    const response = await friendsAPI.post(`/api/events/${eventId}/comments/${commentId}/reactions`, {
      emoji
    })
    return response.data
  },

  removeCommentReaction: async (eventId, commentId) => {
    const response = await friendsAPI.delete(`/api/events/${eventId}/comments/${commentId}/reactions`)
    return response.data
  },

  inviteFriendsToEvent: async (eventId, friendIds, message = '') => {
    const response = await friendsAPI.post(`/api/events/${eventId}/invite`, {
      friendIds,
      message
    })
    return response.data
  },

  respondToEventInvitation: async (eventId, invitationId, response) => {
    const apiResponse = await friendsAPI.put(`/api/events/${eventId}/invitations/${invitationId}`, {
      response
    })
    return apiResponse.data
  }
}